<div class="filters">
  <mat-form-field class="search" appearance="outline">
    <input
      matInput
      [placeholder]="'DEAD_LETTERS.FILTERS.SEARCH_PLACEHOLDER' | translate"
      [value]="filters.searchTerm"
      (input)="onSearchTermChange($any($event.target).value)">
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <mat-form-field class="event-type" appearance="outline">
    <input
      matInput
      [placeholder]="'DEAD_LETTERS.FILTERS.EVENT_TYPE_PLACEHOLDER' | translate"
      [value]="filters.eventType"
      (input)="onEventTypeFilterChange($any($event.target).value)">
    <mat-icon matPrefix>category</mat-icon>
  </mat-form-field>

  <mat-form-field class="date-from" appearance="outline">
    <mat-label>{{ 'DEAD_LETTERS.FILTERS.DATE_FROM' | translate }}</mat-label>
    <input
      matInput
      [matDatepicker]="dateFromPicker"
      [value]="filters.dateFrom"
      [max]="filters.dateTo"
      (dateChange)="onDateFromChange($event.value)">
    <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
    <mat-datepicker #dateFromPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="date-to" appearance="outline">
    <mat-label>{{ 'DEAD_LETTERS.FILTERS.DATE_TO' | translate }}</mat-label>
    <input
      matInput
      [matDatepicker]="dateToPicker"
      [value]="filters.dateTo"
      [min]="filters.dateFrom"
      (dateChange)="onDateToChange($event.value)">
    <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
    <mat-datepicker #dateToPicker></mat-datepicker>
  </mat-form-field>
</div>
